<div style="position:relative;height: 100%;">
<div style="text-align: center;position: absolute;top: 40%;left: 50%;transform: translate(-50%, -50%);">
  <img src="../../assets/images/page-not-found-blank.png">
  <p style="font-size: 4.5rem">{{pageNotFoundHeader}}</p>
  <p>{{ pageNotFoundMessage }}</p>
</div>
</div>

